import { render, staticRenderFns } from "./ReportUpdates.vue?vue&type=template&id=49284a0f&scoped=true"
import script from "./ReportUpdates.vue?vue&type=script&lang=js"
export * from "./ReportUpdates.vue?vue&type=script&lang=js"
import style0 from "./ReportUpdates.vue?vue&type=style&index=0&id=49284a0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49284a0f",
  null
  
)

export default component.exports